import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { first } from 'rxjs';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { DepartmentDashboardService } from 'src/app/services/department-dashboard.service';
import { FarmersDetailsService } from 'src/app/services/farmers-details.service';
import * as XLSX from 'xlsx';


@Component({
  selector: 'app-offline-payment-sheet-epc',
  templateUrl: './offline-payment-sheet-epc.component.html',
  styleUrls: ['./offline-payment-sheet-epc.component.scss']
})
export class OfflinePaymentSheetEpcComponent implements OnInit {

  public userId: any;

  xslxToJsonData: any[] = [];
  uploadFile: any;

  public pfmsPaymentStatusData: any = [];
  public ipAddress: any = '000.000.000';
  public responseDate: any = [];

  public loadingExportResponse: boolean = false;

  constructor(
    private fApplicationService: FarmersDetailsService,
    private loader: AppLoaderService,
    private messageService: MessageService,
    private activityRecordService: ActivityRecordService,
    private deptDashBoardService: DepartmentDashboardService,
    private cryptoJsService: CryptoJsService,
  ) { }

  ngOnInit(): void {
    const token: any = JSON.parse(this.cryptoJsService.DecryptToken(sessionStorage.getItem('token')));    
    let payload = atob(token?.authToken?.split('.')[1]);
    this.userId = JSON.parse(payload)?.sub;

  }

  onUploadPFMSPaymentStatus(event, formcontrol, uploadElement) {
    this.uploadFile = [];
    let workBook = null;
    let jsonData = null;
    let sheetName = null
    const reader = new FileReader();
    let file = event.files[0];
    this.uploadFile = file;
    reader.onload = (event) => {
      const data = reader.result;
      workBook = XLSX.read(data, { type: 'binary', cellText: false, cellDates: true });
      jsonData = workBook.SheetNames.reduce((initial, name) => {
        sheetName = name;
        const sheet = workBook.Sheets[name];
        initial[name] = XLSX.utils.sheet_to_json(sheet, {
          raw: false,
          dateNF: 'yyyy-mm-dd',
        });
        return initial;
      }, {});
      const dataString = JSON.stringify(jsonData);
      let statePhyFinData = JSON.parse(dataString)[sheetName];
      if (!(statePhyFinData)) {
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'The Uploaded file has invalid data "or" Multiple sheet data is not supported!' });
      } else if (statePhyFinData.length == 0) {
        this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'The Uploaded file is empty!' });
      } else {
        this.addUploadedStateData(statePhyFinData);
      }
    }
    reader.readAsBinaryString(file);
    uploadElement.clear();
  }

  addUploadedStateData(value) {
    this.pfmsPaymentStatusData = value.map((val) => ({
      'RDName': val?.['RDName'],
      'NameOfContractor': val?.['NameOfContractor'],
      'FarmerName': val?.['FarmerName'],
      'FatherName': val?.['FatherName'],
      'MotherName': val?.['MotherName'],
      'PPPNo': val?.['PPPNo'],
      'AadharNo': val?.['AadharNo'],
      'AppliedMIArea': val?.['AppliedMIArea'],
      'KILLA_NO': val?.['KILLA_NO'],
      'MARABBA_NO': val?.['MARABBA_NO'],
      'AppId': val?.['AppId'],
      'CASTE': val?.['CASTE']
    }))
  }



  clearPFMSpaymentStatusData() {
    this.pfmsPaymentStatusData = [];
    this.responseDate = [];
  }

  deletePFMSpaymentStatusData(index: number) {
    this.pfmsPaymentStatusData.splice(index, 1);
  }

  onSubmitStatePhyTarDate() {
    let reqBody = [
      {
        // userId: this.userId,
        network_Id: this.ipAddress,
        terminal_Id: this.ipAddress,
        data: this.pfmsPaymentStatusData.map(val => ({
          AppId: val?.AppId,
          RDName: val?.RDName,
          NameOfContractor: val?.NameOfContractor,
          FarmerName: val?.FarmerName,
          FatherName: val?.FatherName,
          MotherName: val?.MotherName,
          PPPNo: val?.PPPNo,
          AadharNo: val?.AadharNo,
          AppliedMIArea: val?.AppliedMIArea,
          KILLA_NO: val?.KILLA_NO,
          MARABBA_NO: val?.MARABBA_NO,
          CASTE: val?.CASTE,
          // pfmsPaymentDate: new Date(val?.PFMSPaymentDate),
        }))
      }
    ]
    this.insertStatePhysicalFinData(reqBody);
  }

  insertStatePhysicalFinData(reqBody) {
    let reqBodyAfterEncypt = {
      "payload": this.cryptoJsService.EncryptPayload(JSON.stringify(reqBody))
    }

    this.loader.start();
    this.loadingExportResponse = true;
    this.deptDashBoardService
      .importEPCOfflinePayment(reqBodyAfterEncypt)
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.loader.close();

          this.loadingExportResponse = false;

          this.responseDate = res;

          this.responseDate.forEach((val, i) => {
            if(val?.IsCorrect == 0){
              this.messageService.add({ severity: 'error', summary: 'Error Message', detail: this.responseDate[i].Message });
              return;
            }
            
            this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Successfully Submitted' });
          });
          this.activityRecordService.activityRecord(this.userId, 'EPC Offline Payment Status', ``, new Date(), `${res}`, reqBody);
        },
        error: (err) => {
          this.loadingExportResponse = false;
          this.responseDate = [];
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });

          this.activityRecordService.activityRecord(this.userId, 'EPC Offline Payment Status Error', ``, new Date(), `${err}`, reqBody);
        },
      });
  }

  responseGridBackgroundColor(product){
    if (product.IsCorrect == 0) {
      return '#ff8080';
    } else return '#ffffff';
  }

}

